export interface IUploadFilesCommand {
    contextName: string,
    directoryId?: string
}

export interface ICreateDirectoryCommand {
    name: string,
    contextName: string,
    directoryId?: string
}

export interface ICreateDirectoryModalContext {
    context: IContextQueryResult,
    directoryId?: string
}

export interface IUploadFileCommandResult {
    fileName: string,
    success: boolean,
    id?: string,
    errorMessage: string
}

export interface IFileManagerModalContext {
    contextName: string;
    allowMultiSelection?: boolean;
}

export interface IContextQueryResult
{
    id: string,
    name: string,
    title: string,
    maxFileSize: number,
    space: ISpaceQueryResult,
}

export interface ISpaceQueryResult {
    id: string,
    name: string,
    type: string,
    basePath: string
}

export interface IListItemQueryResult {
    id: string,
    name: string,
    originalName: string,
    displayName: string,
    isDirectory: boolean,
    extension: string,
    fileSize?: number,
    directoryId?: string,
    contextId?: string,
    createdTime?: string,
    lastUpdatedTime?: string,
    publicUrl?: string
}